module.exports = __webpack_public_path__ + "static/burgermeister-d2e00d4f577e6bd777f2fad8c73b4999.jpg";